export default {"src":"/_next/static/media/paper-fold-text.aff1fd9c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};